
import { Link } from "react-router-dom";
import AkkhorLayout from "../../../layout/AkkhorLayout";
import List from "../../../component/List";


export default function DanhSachChuDauTu() {
  let params = '';
  const columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "title", label: "Tên dự án", options: { filter: true, sort: true } },
    { name: "chudautu", label: "Chủ đầu tư", options: { filter: true, sort: true } },
    { name: "status", label: "Trạng thái", options: { filter: true, sort: true } },
    { name: "datecreate",label: "Ngày tạo",}
  ];
  
  return (<AkkhorLayout idrole="chu-dau-tu">
    <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Danh sách chủ đầu tư
                </li>
            </ul>
        </div>
    <List name="chudautu" idrole="chu-dau-tu" params={params} title="" defaultLimit={50}  serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
